import { Link } from 'react-router-dom'

import { PageNotFound } from '../../components/icons/PageNotFound'

const NotFoundPage = () => {
  return (
    <div className="bg-neutral-200-100 p-32 main-container  text-center">
      <div className="flex justify-center mb-4">
        <div className="bg-red-100 p-4 rounded-full">
          <PageNotFound size={64} />
        </div>
      </div>
      <h1 className="text-xl font-bold text-red-600 mb-2">Page Not Found</h1>
      <p className="text-gray-600 text-sm mb-4">
        The page you're looking for doesn't exist or may have been moved. Please check the URL or go
        back to the homepage.
      </p>

      <div className="flex justify-center gap-4 mt-4 flex-wrap">
        <Link
          to="/"
          className="px-4 py-2 bg-orange-500 hover:bg-orange-600 rounded text-white transition-colors"
        >
          Go To HomePage
        </Link>
      </div>
    </div>
  )
}

export default NotFoundPage
